'use client';

import { useCallback, useEffect, useState } from 'react';
import {
  DEFAULT_STICKY_NOTE_PREFS,
  readStickyNotePrefs,
  writeStickyNoteEnabled,
  writeStickyNoteVariant,
  type StickyNotePrefs,
  type StickyNoteVariant,
} from '@/lib/sticky-note';

// Per-device sticky-note preferences. Defaults match what the user
// got before settings existed (visible, floating variant) so an
// untouched account doesn't lose the chip.
export function useStickyNotePrefs(): {
  prefs: StickyNotePrefs;
  setEnabled: (next: boolean) => void;
  setVariant: (next: StickyNoteVariant) => void;
} {
  const [prefs, setPrefs] = useState<StickyNotePrefs>(DEFAULT_STICKY_NOTE_PREFS);

  useEffect(() => {
    setPrefs(readStickyNotePrefs());
  }, []);

  const setEnabled = useCallback((next: boolean) => {
    setPrefs((p) => ({ ...p, enabled: next }));
    writeStickyNoteEnabled(next);
  }, []);

  const setVariant = useCallback((next: StickyNoteVariant) => {
    setPrefs((p) => ({ ...p, variant: next }));
    writeStickyNoteVariant(next);
  }, []);

  return { prefs, setEnabled, setVariant };
}
